'use client';

import { useEffect } from 'react';

import classnames from 'classnames';

import type { BaseComponentProps } from '../base-component.types';
import { Toast } from '../toast';
import { useToaster, useToasterActions } from './toasterStore';

import styles from './Toaster.module.scss';

const MESSAGE_TTL_MS = 60000;
const SWEEP_INTERVAL_MS = 1000;

function Toaster({ className, testId = 'ui-toaster' }: BaseComponentProps) {
  const messages = useToaster();
  const { deleteMessage } = useToasterActions();

  useEffect(() => {
    const interval = setInterval(() => {
      const now = Date.now();

      messages
        .filter((message) => message.timestamp < now - MESSAGE_TTL_MS)
        .forEach((message) => {
          deleteMessage(message.id);
        });
    }, SWEEP_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [messages, deleteMessage]);

  if (messages.length === 0) {
    return null;
  }

  return (
    <div className={classnames(styles['main'], className)} data-testid={testId}>
      {messages.map((item) => (
        <Toast
          key={item.id}
          message={{
            id: item.id,
            title: item.title,
            timestamp: item.timestamp,
            text: item.message,
          }}
          variant={item.variant}
          onClose={() => deleteMessage(item.id)}
        />
      ))}
    </div>
  );
}

export { Toaster };
